<div class="controls-wrapper">
    <h1 *ngIf="title">{{ title | transloco }}</h1>
    <button (click)="toggle()" [ngClass]="filterExpanded ? 'expanded' : ''" mat-icon-button class="filter-trigger">
        <div class="filter-button">
            <mat-icon aria-hidden="false" aria-label="filter icon" class="filter-icon">filter_alt</mat-icon>
        </div>
    </button>
    <div class="controls">
        <ng-content></ng-content>
    </div>
</div>

<div class="filter-wrapper" [ngClass]="filterExpanded ? 'expanded' : ''">
    <div class="filter-group" *ngFor="let filterGroup of filterFormList.controls">
        <h3 *ngIf="filterGroup.get('title')?.value">
            {{ filterGroup.get('title')?.value | transloco }}
        </h3>

        <div class="filter-controls-wrapper">
            <liebherr-filter-control *ngFor="let control of $any(filterGroup.get('filterControls')).controls" [control]="control" [width]="filterControlWidth"></liebherr-filter-control>
        </div>
    </div>
</div>
<ng-container *im2mLet="selectedFilter$ | async as selectedFilter">
    <im2m-chips [chips]="selectedFilter" (removeChip)="clearFilter($event)"></im2m-chips>
</ng-container>
